import { Button, Stack, Typography, useTheme } from '@mui/material';
import { CandidateAction } from 'features/Principal/types/candidatesListTypes';
import { primaryButtonOverrideSx } from 'sharedComponents/Buttons/styles';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import { getButtonSx } from './CandidateActionButtons';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';
import { ATSPrincipalAppCandidatesListTestIds } from 'data-testids/ATS';

export const ModalCandidateActionButtons = ({
  confirmDialogOpen,
  onClick,
  onConfirm,
  pendingAction,
  status,
  isSelectForHire,
  isInTerminalStatus,
}) => {
  const theme = useTheme();

  const text =
    pendingAction === CandidateAction.NOT_A_FIT
      ? "This will mark this candidate as Not a Fit and remove them from consideration for this role. This action can't be undone."
      : "This will mark this candidate as Selected for Hire and notify your administrator. This action can't be undone.";

  return (
    <Stack alignItems="center" sx={{ width: '100%' }}>
      {!confirmDialogOpen && (
        <Stack direction="row" sx={{ width: '100%' }}>
          <Button
            data-testid={ATSPrincipalAppCandidatesListTestIds.NOT_A_FIT_BUTTON}
            sx={{
              ...primaryButtonOverrideSx(theme),
              ...getButtonSx(CandidateAction.NOT_A_FIT, theme, isInTerminalStatus, status),
              width: '33%',
              mr: 1,
            }}
            startIcon={<CloseIcon />}
            variant="outlined"
            color="error"
            onClick={() => onClick(CandidateAction.NOT_A_FIT)}
          >
            Not a Fit
          </Button>
          <Button
            sx={{
              ...primaryButtonOverrideSx(theme),
              ...getButtonSx(CandidateAction.IN_CONSIDERATION, theme, isInTerminalStatus, status),
              width: '33%',
              mr: 1,
            }}
            startIcon={<QuestionMarkIcon />}
            variant="outlined"
            color="warning"
            onClick={() => onClick(CandidateAction.IN_CONSIDERATION)}
            data-testid={ATSPrincipalAppCandidatesListTestIds.IN_CONSIDERATION_BUTTON}
          >
            In Consideration
          </Button>
          <Button
            sx={{
              ...primaryButtonOverrideSx(theme),
              ...getButtonSx(CandidateAction.SELECTED_FOR_HIRE, theme, isInTerminalStatus, status),
              width: '33%',
            }}
            startIcon={<CheckIcon />}
            variant="outlined"
            onClick={() => onClick(CandidateAction.SELECTED_FOR_HIRE)}
            data-testid={ATSPrincipalAppCandidatesListTestIds.SELECTED_FOR_HIRE_BUTTON}
          >
            Select for Hire
          </Button>
        </Stack>
      )}
      {isSelectForHire && (
        <Typography
          variant="body3"
          sx={{ color: theme.palette.text.secondary, fontStyle: 'italic', mt: 0.5, fontSize: 10 }}
          data-testid={ATSPrincipalAppCandidatesListTestIds.ACTION_NOTIFIED_TEXT}
        >
          Your administrator has been notified
        </Typography>
      )}
      {confirmDialogOpen && (
        <>
          <Typography
            sx={{ pb: 2 }}
            data-testid={ATSPrincipalAppCandidatesListTestIds.MODAL_CONFIRMATION_TEXT}
          >
            {text}
          </Typography>
          <Stack direction="row" alignItems="end">
            <Button
              variant="outlined"
              sx={{ ...primaryButtonOverrideSx(theme), mr: 1 }}
              onClick={() => onConfirm(false)}
              data-testid={ATSPrincipalAppCandidatesListTestIds.MODAL_CANCEL_BUTTON}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              sx={primaryButtonOverrideSx(theme)}
              onClick={() => onConfirm(true)}
              data-testid={ATSPrincipalAppCandidatesListTestIds.MODAL_CONTINUE_BUTTON}
            >
              Continue
            </Button>
          </Stack>
        </>
      )}
    </Stack>
  );
};
